<template>
        <el-dialog
            class="add_or_edit_dialog"
            :title="title"
            :visible.sync="openAddOrEditDialog"
            top="4%"
            width="400px"
            style="padding: 0 50px 50px 0;"
            :before-close="closeDialog">
            <el-form ref="form" :model="form" :rules="rules" label-width="140px" size="mini">
                <el-form-item prop="supplierType" label="供应商类型" style="width:100%;">
                    <m-Select :optionNum="'SYS_SUPPLIERS_TYPE'" :flag="'supplierType'" :value="form.supplierType"
                    :filterable="true" @input="val => getSelectedValue(val, 'supplierType')"></m-Select>
                </el-form-item>
                <el-form-item prop="property" label="主体性质" style="width:100%;">
                    <m-Select :optionNum="'SYS_SUPPLIERS_PROPERTY'" :flag="'property'" :value="form.property"
                    :filterable="true" @input="val => getSelectedValue(val, 'property')"></m-Select>
                </el-form-item>
                <el-form-item v-if="isOverseasVisible" prop="isOverseas" label="涉外业务类型" style="width:100%;">
                    <m-Select
                        :optionNum="'SRM_IS_OVERSEAS'"
                        :flag="'isOverseas'"
                        :value="form.isOverseas"
                        :filterable="true"
                        :disabled="form.supplierType === INNER_SUPPLIER"
                        @input="val => getSelectedValue(val, 'isOverseas')"
                    ></m-Select>
                </el-form-item>
                <el-form-item
                    prop="businessType" label="业务类型" style="width:100%;">
                    <m-Select :optionNum="'SRM_BUSYNESS_TYPE_BACKGROUND'" :flag="'businessType'" :value="form.businessType"
                    :filterable="true" @input="val => getSelectedValue(val, 'businessType')"></m-Select>
                </el-form-item>
                <el-form-item
                    prop="transportType" label="运输方式" style="width:100%;">
                    <m-Select :optionNum="'SRM_TRANSPORT_TYPE'" :flag="'transportType'" :value="form.transportType"
                    :filterable="true" @input="val => getSelectedValue(val, 'transportType')"></m-Select>
                </el-form-item>
                <el-form-item
                    prop="transType" label="承运商类型" style="width:100%;">
                    <m-Select :optionNum="'SRM_SHIPPER_TYPE'" :flag="'transType'" :value="form.transType" :disabledOptions="disabledOptions"
                    :filterable="true" @input="val => getSelectedValue(val, 'transType')"></m-Select>
                </el-form-item>
                <el-form-item
                    prop="corporateType" label="合作方式" style="width:100%;">
                    <m-Select :optionNum="'SU_CORPORATE_TYPE'" :flag="'corporateType'" :value="form.corporateType"
                    :filterable="true" @input="val => getSelectedValue(val, 'corporateType')"></m-Select>
                </el-form-item>
                <el-form-item
                    prop="lesseeType" label="租赁商类别" style="width:100%;">
                    <m-Select :optionNum="'SU_LEASE_TYPE'" :flag="'lesseeType'" :value="form.lesseeType"
                    :filterable="true" @input="val => getSelectedValue(val, 'lesseeType')"></m-Select>
                </el-form-item>
                <el-form-item
                    prop="driverNumber" label="司机数量" style="width:100%;">
                    <el-input v-model.number="form.driverNumber" :filterable="true"></el-input>
                </el-form-item>
                <el-form-item
                    prop="vehiclesNumber" label="车辆数量" style="width:100%;">
                    <el-input v-model.number="form.vehiclesNumber" :filterable="true"></el-input>
                </el-form-item>
                <el-form-item prop="cooperationWays" label="合作方式(其他)" style="width:100%;" v-if="isOtherSupplier">
                    <m-Select :optionNum="'SU_CORPORATE_TYPE_RL'" :flag="'cooperationWays'" :value="form.cooperationWays"
                    :filterable="true"  @input="val => getSelectedValue(val, 'cooperationWays')"></m-Select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button v-if="addOrEdit" type="primary" @click="confirmDialog">确 定</el-button>
                <el-button v-else v-has="'04000102'" type="primary" @click="confirmDialog">确 定</el-button>
            </span>
        </el-dialog>
</template>

<script>
import { LOGISTICS_SUPPLIER, INNER_SUPPLIER, NOT_INVOLVE, TRANSPORTATION_NUM, EXPRESS_NUM, STORAGE_NUM, SEA_TRANSPORTATION_NUM, LEASING_STORAGE_NUM } from '../../../../constant/constant.js';
import { OTHER_SUPPLIER } from '../../../../constant/supplierListConstant.js';
// import mSelect from '../../../../components/Select.vue';
import mSelect from '@/components/lots/otpSelect2'

const positiveIntegerVerify = new RegExp(/^\d+$/);

export default {
    name: 'add-or-edit-dialog',
    components: { mSelect },
    props: {
        openAddOrEditDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        addOrEdit: {
            type: Boolean,
            default() {
                return false;
            }
        },
        row: {
            type: Object,
            default() {
                return {};
            }
        },
        overseaSwitch: {
            type: Boolean,
            default() {
                return true;
            }
        },
    },
    data() {
        return {
            LOGISTICS_SUPPLIER,
            INNER_SUPPLIER,
            TRANSPORTATION_NUM,
            EXPRESS_NUM,
            STORAGE_NUM,
            SEA_TRANSPORTATION_NUM,
            LEASING_STORAGE_NUM,
            allow: false,
            form: {
                supplierType: '',
                property: '',
                isOverseas: '',
                businessType: '',
                transportType: '',
                transType: '',
                corporateType: '',
                lesseeType: '',
                driverNumber: '',
                vehiclesNumber: '',
                cooperationWays: ''
            },
            rules: {
                supplierType: [
                    { required: true, message: '请选择供应商类型', trigger: ['change'] }
                ],
                property: [
                    { required: true, message: '请选择主体性质', trigger: ['change'] }
                ],
                isOverseas: [
                    { required: true, message: '请选择涉外业务类型', trigger: ['change'] }
                ],
                driverNumber: [
                    { pattern: positiveIntegerVerify, message: '司机数量必须为正整数', trigger: 'blur' }
                ],
                vehiclesNumber: [
                    { pattern: positiveIntegerVerify, message: '车辆数量必须为正整数', trigger: 'blur' }
                ]
            }
        };
    },
    computed: {
        title() {
            return this.addOrEdit ? '新增' : '编辑';
        },
        isOtherSupplier() { // 供应商类型：其他供应商 时，显示合作方式(其他)
            return this.form.supplierType === OTHER_SUPPLIER;
        },
        disabledOptions(){
            return this.form.businessType === '3' ? ['40'] : []
        },
        isOverseasVisible() {
            return this.overseaSwitch && (this.form.supplierType === LOGISTICS_SUPPLIER ||
                (this.form.supplierType === INNER_SUPPLIER && this.form.businessType))
        },
    },
    methods: {
        getSelectedValue(val, prop) {
            this.$set(this.form, prop, val);
            if (prop === 'supplierType' && val !== LOGISTICS_SUPPLIER) {
                this.form.isOverseas = ''
            }
            if(prop === 'businessType' && val === '3' && this.form.transType === '40'){
                //业务类型=运输 & 承运商类别=车队供应商，则清空承运商类别
                this.form.transType = ''
            }
            if (this.form.supplierType === INNER_SUPPLIER) {
                this.form.isOverseas = !!this.form.businessType ? NOT_INVOLVE : ''
            }
        },
        closeDialog() {
            this.form = {
                supplierType: '',
                property: '',
                isOverseas: '',
                businessType: '',
                transportType: '',
                transType: '',
                corporateType: '',
                lesseeType: ''
            };
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
                this.$emit('closeDialog', false);
            })
        },
        confirmDialog() {
            this.handleVerify();
            if (this.allow) {
                const submitForm = JSON.parse(JSON.stringify(this.form));
                this.$emit('confirmDialog', {
                    data: Object.assign({}, submitForm),
                    addOrEdit: this.addOrEdit,
                    close: false
                });
                this.form = {};
                this.$refs['form'].resetFields();
            }
            this.allow = false;
        },
        handleVerify() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.allow = true;
                }
            });
        }
    },
    watch: {
        row: {
            handler() {
                this.form = Object.assign({}, {
                    supplierType: this.row.supplierType ? '' + this.row.supplierType : this.row.supplierType,
                    property: this.row.property ? '' + this.row.property : this.row.property,
                    isOverseas: this.row.isOverseas ? '' + this.row.isOverseas : this.row.isOverseas,
                    businessType: this.row.businessType ? '' + this.row.businessType : this.row.businessType,
                    transportType: this.row.transportType ? '' + this.row.transportType : this.row.transportType,
                    corporateType: this.row.corporateType ? '' + this.row.corporateType : this.row.corporateType,
                    lesseeType: this.row.lesseeType ? '' + this.row.lesseeType : this.row.lesseeType,
                    transType: this.row.transType ? '' + this.row.transType : this.row.transType,
                    driverNumber: this.row.driverNumber,
                    vehiclesNumber: this.row.vehiclesNumber
                });
            },
            deep: true
        }
    }
};
</script>

<style lang="less">
    .add_or_edit_dialog {
        .el-dialog__body {
            padding: 16px 80px 0 0;
        }
    }
</style>
